import { Box, Flex, Grid, List, Text } from '@chakra-ui/react';
import DocumentCard from '../../components/DocumentCard';
import { useContext, useState } from 'react';
import { GraphViewContext } from './Index';
import { useAppSelector } from '../../lib/hooks';
import SortDropdown from '../../components/SortDropdown';
import sortNodes from '../../lib/Sort';

export default function ListView() {
  const graphView = useContext(GraphViewContext);
  // const filter = useAppSelector((state) => state.viewReducer.graphViews[graphView.id].filter);
  const [sortOrder, setSortOrder] = useState<'default' | 'date' | 'relevance'>('default');
  console.log(graphView.serializedGraph?.nodes);
  
  return (
    <Box
      backgroundColor="background"
      style={{
        position: 'relative',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        overflowY: 'auto',
      }}
    >
      {/* <Flex direction={'row'} justifyContent={'space-between'}> */}
      {/*   <Text fontWeight={800} fontSize="x-large" paddingBottom="20px"> */}
      {/*     List of all cases in this graph */}
      {/*   </Text> */}
      {/*   <SortDropdown setSortOrder={setSortOrder} sortOrder={sortOrder} /> */}
      {/* </Flex> */}
      <Grid
        padding={4}
        style={{
          height: '100%',
          borderRadius: '10px',
          overflowY: 'scroll',
          scrollbarWidth: 'thin',
          justifyItems: 'center',
        }}
        templateColumns={'repeat(auto-fit, minmax(380px, 1fr))'}
        gap={4}
      >
        {graphView.serializedGraph?.nodes.map((node) => (
          <DocumentCard nodeId={node.attributes.id} id={node.attributes.id} />
        ))}
      </Grid>
      {/* <List
        spacing={'8px'}
        width={'100%'}
        alignItems={'center'}
        display={'flex'}
        flexDirection={'column'}
      >
        {sortNodes(filterNodes(props.data.nodes, filter), sortOrder).map((node) => (
          <DocumentCard key={node.properties.id} id={node.properties.id}></DocumentCard>
        ))}
      </List> */}
    </Box>
  );
}
